import { render, staticRenderFns } from "./prepare-task.vue?vue&type=template&id=187a3734"
import script from "./prepare-task.vue?vue&type=script&lang=js"
export * from "./prepare-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports